import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleGuide from "../pages/article-guide/page";
import ArticleSafety from "../pages/article-safety/page";
import ArticleComparison from "../pages/article-comparison/page";
import ArticleTutorial from "../pages/article-tutorial/page";
import ArticleReview from "../pages/article-review/page";
import ArticleHowto from "../pages/article-howto/page";
import ArticleAlternatives from "../pages/article-alternatives/page";
import ArticleBeginners from "../pages/article-beginners/page";
import ArticleFeatures from "../pages/article-features/page";
import ArticlePrivacy from "../pages/article-privacy/page";
import ArticleMobile from "../pages/article-mobile/page";
import ArticleTips from "../pages/article-tips/page";
import ArticleIntegration from "../pages/article-integration/page";
import ArticleCommunity from "../pages/article-community/page";
import ShoppingGuide from "../pages/shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/przewodnik-usfansspreadsheet",
    element: <ArticleGuide />,
  },
  {
    path: "/artykul/bezpieczenstwo-usfansspreadsheet",
    element: <ArticleSafety />,
  },
  {
    path: "/artykul/porownanie-usfansspreadsheet",
    element: <ArticleComparison />,
  },
  {
    path: "/artykul/jak-korzystac-usfansspreadsheet",
    element: <ArticleTutorial />,
  },
  {
    path: "/artykul/opinia-usfansspreadsheet",
    element: <ArticleReview />,
  },
  {
    path: "/artykul/jak-uzywac-usfansspreadsheet",
    element: <ArticleHowto />,
  },
  {
    path: "/artykul/alternatywy-usfansspreadsheet",
    element: <ArticleAlternatives />,
  },
  {
    path: "/artykul/dla-poczatkujacych",
    element: <ArticleBeginners />,
  },
  {
    path: "/artykul/funkcje-usfansspreadsheet",
    element: <ArticleFeatures />,
  },
  {
    path: "/artykul/prywatnosc-usfansspreadsheet",
    element: <ArticlePrivacy />,
  },
  {
    path: "/artykul/mobilny-usfansspreadsheet",
    element: <ArticleMobile />,
  },
  {
    path: "/artykul/wskazowki-usfansspreadsheet",
    element: <ArticleTips />,
  },
  {
    path: "/artykul/integracja-usfansspreadsheet",
    element: <ArticleIntegration />,
  },
  {
    path: "/artykul/spolecznosc-usfansspreadsheet",
    element: <ArticleCommunity />,
  },
  {
    path: "/przewodnik-zakupowy",
    element: <ShoppingGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;